import { get } from '../index';

export const getCountriesAndStatesData = () => {
  return get(`/countries`);
};
